import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { getCurrentCompany } from '../../../apis/companies/index';
import { useAuth } from '../../../components/auth/AuthProvider.tsx';
import { ContentsHeader } from '../../../components/common/ContentsHeader';
import { CompanyType } from '../../../types/resources/CompanyType';
import { convertDateTime } from '../../../utils/dateTime';
import styles from './styles.module.scss';

export const ShowCompany: React.FC = () => {
  const [company, setCompany] = useState<CompanyType>();
  const { showToast } = useToast();
  const { signOut } = useAuth();
  const fetchCompany = async () => {
    try {
      const companyData = await getCurrentCompany(signOut);
      setCompany(companyData.company);
    } catch {
      showToast({ message: 'データの取得に失敗しました。', status: 'danger' });
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  if (!company) {
    return (
      <div className={styles.loading}>
        <CircularProgress size='1rem' color='inherit' />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <ContentsHeader title='事業者情報' />
      <div className={styles.container}>
        <div className={styles.mainContainer}>
          <div className={styles.form}>
            <div className={styles.formTitle}>企業名</div>
            <div data-testid='company-name'>{company.name}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>担当者の氏名</div>
            <div data-testid='contact-person-name'>{company.contact_person_name}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>担当者メールアドレス</div>
            <div data-testid='contact-person-email'>{company.email}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>電話番号</div>
            <div data-testid='contact-person-phone'>{company.phone}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>公式サイトURL</div>
            <div data-testid='official-site-url'>{company.official_site_url}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>プライバシーポリシーURL</div>
            <div data-testid='privacy-policy-url'>{company.privacy_policy_url}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>作成日時</div>
            <div data-testid='created-at'>{convertDateTime(company.created_at)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
